import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';
import * as moment from 'moment';

const BASE_URL: string = environment.API_URL;

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  constructor(private http: HttpClient) {
    
  }

  public getTotals(): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/dashboard`, {headers});
  }

  public getTopCourses(): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/topcourses`, {headers});
  }

  getCoursesImparted(idRol: string) {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/teacherCourses/${idRol}`, {headers});
  }

  getStudentsRegistered(id: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    
    // Crear observable que combine datos del servidor y locales
    return new Observable(observer => {
      // Primero intentar obtener datos del servidor
      this.http.get<any>(`${BASE_URL}/getStudents/${id}`, {headers}).subscribe({
        next: (serverStudents) => {
          console.log('✅ [DASHBOARD] Estudiantes del servidor:', serverStudents);
          
          // Obtener estudiantes locales
          const localStudents = this.getLocalStudents(id);
          console.log('📱 [DASHBOARD] Estudiantes locales:', localStudents);
          
          // Combinar ambas listas (evitando duplicados por email)
          const allStudents = [...serverStudents];
          localStudents.forEach(localStudent => {
            const exists = serverStudents.find((s: any) => s.email === localStudent.email);
            if (!exists) {
              allStudents.push(localStudent);
            }
          });
          
          console.log('📊 [DASHBOARD] Total de estudiantes combinados:', allStudents.length);
          observer.next(allStudents);
          observer.complete();
        },
        error: (error) => {
          console.warn('⚠️ [DASHBOARD] Error del servidor, usando solo datos locales:', error);
          
          // Si falla el servidor, usar solo datos locales
          const localStudents = this.getLocalStudents(id);
          console.log('📱 [DASHBOARD] Usando solo estudiantes locales:', localStudents);
          
          observer.next(localStudents);
          observer.complete();
        }
      });
    });
  }

  // Obtener estudiantes locales para un instructor específico
  private getLocalStudents(instructorId: any): any[] {
    try {
      const allLocalStudents = JSON.parse(localStorage.getItem('students') || '[]');
      return allLocalStudents.filter((student: any) => 
        student.instructorId === instructorId || student.instructorId === instructorId.toString()
      );
    } catch (error) {
      console.error('❌ [DASHBOARD] Error al obtener estudiantes locales:', error);
      return [];
    }
  }

  public getTopMembers(): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/topmembers`, {headers});
  }

  public getCoursesGraph(): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.get<any>(`${BASE_URL}/coursesgraph`, {headers});
  }

  public getDashDates(): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    const startDate = moment().startOf('month').format('YYYY-MM-DD');
    const endDate   = moment().endOf('month').format('YYYY-MM-DD');
    return this.http.get<any>(`${BASE_URL}/dashboarddates?StartDate=${startDate}&EndDate=${endDate}`, {headers});
  }

}
